import { CAPABILITIES } from "@/data/capabilities";
import { SITE, url } from "@/data/site";
import PageShell from "@/components/PageShell";
import CapabilityIndex from "@/components/home/CapabilityIndex";
import { PageTitle, Section } from "@/components/shared/Primitives";

const CANONICAL = url("/capabilities");

const JSON_LD = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "CollectionPage",
      name: "Capabilities — Elentara",
      url: CANONICAL,
      description: "The five capability areas of Elentara, a creative technology studio.",
      isPartOf: { "@id": `${SITE.base}/#website` },
      about: { "@id": `${SITE.base}/#organization` },
      mainEntity: {
        "@type": "ItemList",
        itemListElement: CAPABILITIES.map((c, i) => ({
          "@type": "ListItem",
          position: i + 1,
          name: c.name,
          url: url(`/capabilities/${c.slug}`),
        })),
      },
    },
    {
      "@type": "BreadcrumbList",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "Elentara", item: url("/") },
        { "@type": "ListItem", position: 2, name: "Capabilities", item: CANONICAL },
      ],
    },
  ],
};

const CAPABILITIES_SEO = {
  title: "Capabilities — Immersive Web, 3D & Creative Technology | Elentara",
  description:
    "Five capability areas: digital experiences, creative technology, 3D design and motion, innovation labs and interactive solutions — Elentara creative technology studio.",
  canonical: CANONICAL,
  jsonLd: JSON_LD,
};

export default function Capabilities() {
  return (
    <PageShell
      testId="capabilities-page"
      finalCtaFrom="capabilities"
      seo={CAPABILITIES_SEO}
    >
      <Section testId="capabilities-hero" className="!pt-36 !pb-8">
        <PageTitle
          overline="Capabilities"
          testId="capabilities-title"
          title="Capabilities"
          lead="Five areas, one team. Design, 3D and engineering are never separate disciplines here — they are the same conversation."
        />
      </Section>
      <CapabilityIndex
        sectionId="capability-list"
        testId="capabilities-list"
        overline="What we do"
        title="Tuned like instruments."
      />
    </PageShell>
  );
}
